const bioStatusTypes = {
    CLOSED: "3",//đóng
    BLOCKED: "2", //treo
    ACTIVE: "1", //hoạt động
    DISABLE: "0", //chưa đk
}

export default bioStatusTypes